import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Typography } from '@mui/material';


export default function AlertDialogSlide({ open, setOpen, handleDeleteByModal }) {

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelte = () => {
        handleDeleteByModal()
    }
    return (
        <React.Fragment>
            <Dialog
                open={open}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="h6" sx={{ color: 'red' }}>
                            Confirm Deletion
                        </Typography>
                    </Box>
                </DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" sx={{ fontSize: '1rem' }}>
                        Are you sure you want to delete this?
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ paddingX: 3, paddingBottom: 2 }}>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        color="primary"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDelte}
                        variant="contained"
                        color="error"
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
